var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import iconTypes from './StepIconTypes';
var usePercentageData = function (steps) {
    var flattenSteps = steps.reduce(function flattenHelper(newSteps, step) {
        if (step === null) {
            return newSteps;
        }
        if (step.subSteps) {
            return step.subSteps.reduce(flattenHelper, __spreadArray(__spreadArray([], __read(newSteps)), [step]));
        }
        return __spreadArray(__spreadArray([], __read(newSteps)), [step]);
    }, []);
    var completedCount = 0;
    var stepCount = flattenSteps.length;
    // console.log(flattenSteps);
    flattenSteps.forEach(function (step) {
        if (step.status === iconTypes.completed) {
            completedCount += 1;
        }
    });
    return [stepCount, completedCount];
};
export default usePercentageData;
